import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Layout } from './components/layout';
import { LoginPage } from './pages/login';
import { JobsPage } from './pages/jobs';
import { PostsPage } from './pages/posts';
import { NewPostPage } from './pages/new-post';
import { GalleryPage } from './pages/gallery';
import { NewsletterPage } from './pages/newsletter';
import { VehiclesPage } from './pages/vehicles';
import { VehicleEditPage } from './pages/vehicle-edit';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { token } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export function App() {
  const { token } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={token ? <Navigate to="/jobs" replace /> : <LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/jobs" replace />} />
        <Route path="jobs" element={<JobsPage />} />
        <Route path="posts" element={<PostsPage />} />
        <Route path="posts/new" element={<NewPostPage />} />
        <Route path="vehicles" element={<VehiclesPage />} />
        {/* `new` before `:id` so it isn't swallowed as an id — and the editor
            distinguishes the two by whether the param is present. */}
        <Route path="vehicles/new" element={<VehicleEditPage />} />
        <Route path="vehicles/:id" element={<VehicleEditPage />} />
        <Route path="gallery" element={<GalleryPage />} />
        <Route path="newsletter" element={<NewsletterPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/jobs" replace />} />
    </Routes>
  );
}
